import type { FaireProductEntity } from "../../entity_types/product";

export const faire_nudge_9: FaireProductEntity = {
  token: "faire_nudge_9",
  type: "product",
  name: "Bergamot Candle",
  brandName: "Candle Brand",
  imageUrl:
    "https://images.unsplash.com/photo-1543332164-6e82f355badc?w=100&h=100&fit=crop",
  priceDollars: 18,
  msrpDollars: 36,
  description: "Migrated candle ops mock product",
  tags: ["candle", "ops"],
  freeShipping: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "playground-data-migration",
  },
};
